import React from 'react';
import { RoleBadge } from './Badges';
import { CornerDownRight, Paperclip } from 'lucide-react';
import { t } from '../utils/translations';
import { API_URL } from '../utils/api';

/* Flatten tree into an ordered array with depth info, no recursion */
function flattenTree(replyList) {
  var map = {};
  var roots = [];
  var flat = [];

  replyList.forEach(function(r) {
    map[r._id] = { data: r, childIds: [] };
  });

  replyList.forEach(function(r) {
    if (r.parent_reply_id && map[r.parent_reply_id]) {
      map[r.parent_reply_id].childIds.push(r._id);
    } else {
      roots.push(r._id);
    }
  });

  /* BFS / stack-based DFS to flatten */
  var stack = roots.map(function(id) { return { id: id, depth: 0 }; }).reverse();
  while (stack.length > 0) {
    var item = stack.pop();
    var node = map[item.id];
    if (!node) continue;
    flat.push({ reply: node.data, depth: item.depth });
    var kids = node.childIds.slice().reverse();
    kids.forEach(function(cid) {
      stack.push({ id: cid, depth: item.depth + 1 });
    });
  }

  return flat;
}

function ReplyList({ replies, lang, onReplyTo, canReply }) {
  var items = flattenTree(replies);

  return (
    <div>
      {items.map(function(item) {
        var reply = item.reply;
        var depth = item.depth;
        return (
          <div key={reply._id} data-testid={"reply-" + reply._id} className="animate-fade-in" style={{ marginLeft: depth * 12 }}>
            <div className="apollo-card p-4 mb-2">
              <div className="flex items-center gap-2 mb-2 flex-wrap">
                {reply.posted_as === 'support' ? (
                  <>
                    <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: 'rgba(247,127,0,0.25)' }}>
                      <span style={{ color: '#F77F00', fontWeight: 700, fontSize: 11 }}>SA</span>
                    </div>
                    <span data-testid={"reply-signed-as-support-" + reply._id} className="font-medium text-sm" style={{ color: '#F77F00' }}>{t('post_as_support', lang)}</span>
                    <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(247,127,0,0.12)', color: '#F77F00', border: '1px solid rgba(247,127,0,0.3)' }}>SUPPORT</span>
                  </>
                ) : (
                  <>
                    <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: 'rgba(247,127,0,0.15)' }}>
                      <span style={{ color: '#F77F00', fontWeight: 600, fontSize: 12 }}>{reply.author_name ? reply.author_name.charAt(0) : 'U'}</span>
                    </div>
                    <span className="font-medium text-sm text-white">{reply.author_name}</span>
                    <RoleBadge role={reply.author_role} />
                  </>
                )}
                <span className="text-xs" style={{ color: '#6B7280' }}>
                  {new Date(reply.created_at).toLocaleString(lang === 'fr' ? 'fr-FR' : 'en-US')}
                </span>
              </div>
              <p className="text-sm text-white whitespace-pre-wrap mb-1">{lang === 'en' ? (reply.content_en || reply.content_fr) : reply.content_fr}</p>
              {reply.content_en && lang === 'fr' ? (
                <p className="text-xs italic mt-1" style={{ color: '#9CA3AF' }}>EN: {reply.content_en}</p>
              ) : null}
              {reply.content_fr && lang === 'en' && reply.content_en ? (
                <p className="text-xs italic mt-1" style={{ color: '#9CA3AF' }}>FR: {reply.content_fr}</p>
              ) : null}
              {reply.attachments && reply.attachments.length > 0 ? (
                <div data-testid={"reply-attachments-" + reply._id} className="flex gap-2 flex-wrap mt-2">
                  {reply.attachments.map(function(att) {
                    var tok = encodeURIComponent(localStorage.getItem('apollo_token') || '');
                    return (
                      <a key={att.id} href={API_URL + '/api/replies/' + reply._id + '/attachments/' + att.id + '?token=' + tok} target="_blank" rel="noreferrer"
                        className="flex items-center gap-2 px-2.5 py-1.5 rounded-md text-xs max-w-full"
                        style={{ background: 'rgba(247,127,0,0.08)', color: '#F77F00', border: '1px solid rgba(247,127,0,0.15)' }}>
                        <Paperclip size={11} className="flex-shrink-0" /> <span className="truncate" style={{ maxWidth: 180 }}>{att.filename}</span>
                      </a>
                    );
                  })}
                </div>
              ) : null}
              {canReply && depth < 2 ? (
                <button onClick={function() { onReplyTo(reply._id); }} className="flex items-center gap-1 mt-2 text-xs" style={{ color: '#F77F00' }}>
                  <CornerDownRight size={12} /> {t('reply', lang)}
                </button>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ReplyList;
